import {Injectable} from '@angular/core';
import {ApiRoutes} from "../../../config/api-routes";
import {HttpClient} from "@angular/common/http";
import {LoginSuccessResponse} from "../model/login-success-response";
import {TrustBrowserRequest} from "../../two-factor-auth/trust-browser-request";
import {DeviceService} from "./device.service";
import {take} from "rxjs";

const LOGIN_ID_KEY = 'TWO_FACTOR_LOGIN_ID';
@Injectable()
export class TwoFactorService {

    constructor(
        private readonly api: ApiRoutes,
        private readonly httpClient: HttpClient,
        private readonly device: DeviceService,
    ) {
    }

    public get loginId() {
        return parseInt(localStorage.getItem(LOGIN_ID_KEY));
    }

    public set loginId(value: number) {
        localStorage.setItem(LOGIN_ID_KEY, `${value}`);
    }

    public authenticateWith(otp: string) {
        const payload: TrustBrowserRequest = {
            oneTimeValidationCode: otp,
            browserTrustKey: this.device.deviceId,
            loginId: this.loginId,
        };
        return this.httpClient.post<LoginSuccessResponse>(
            this.api.TRUST_BROWSER, payload,
        );
    }

    public reset() {
        delete this.loginId;
    }
}
